export enum URL_API {
  LOGIN = "https://amz-api.codev.vn/api/login",
  SCAN = "https://amz-api.codev.vn/api/check_code",
  ACCEPT = "https://amz-api.codev.vn/api/accept_code",
  SEARCH = "https://amz-api.codev.vn/api/search",
  APP_THEME = "https://amz-api.codev.vn/api/app_theme",
}
